import { render, staticRenderFns } from "./BaseChessList.vue?vue&type=template&id=8a80e250&scoped=true"
import script from "./BaseChessList.vue?vue&type=script&lang=js"
export * from "./BaseChessList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a80e250",
  null
  
)

export default component.exports